// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2984) return "2984.f5455d07b7621e94a5b0.css";
	if (chunkId === 8138) return "8138.2e288fcc3e351ce17ec3.css";
	// return url for filenames based on template
	return "" + (chunkId === 4402 ? "kindsumNewDetails" : chunkId) + "." + {"2056":"b056c7a1c2548463783b","2694":"3a8562b8be1c694852fe","2869":"46ed01c728b3c2c93fe3","3113":"1c91cd1e94d4f783b65a","3924":"5f3ba7bd875f61d0c9f9","4402":"9b90dd29f123a7daf117","7697":"7cc5860e905af5f675a7","9114":"22383496310d8e0bd937"}[chunkId] + ".css";
};